<template>
    <v-feedback tag="div" class="form-group" v-slot="feedback">
        <label :for="id" v-html="label" v-if="label"></label>
        <slot></slot>
        <div class="invalid-feedback d-block" v-if="feedback && !allFeedback" v-html="feedback[0]"></div>
        <div class="invalid-feedback d-block" v-if="feedback && allFeedback" v-for="message in feedback" v-html="message"></div>
    </v-feedback>
</template>

<script>
    import VFeedback from "./VFeedback";
    export default {
        components: {VFeedback},
        name: 'VField',
        props: {
            label: {
                type: String,
            },
            "all-feedback": {
                type: Boolean,
            },
        },
        data () {
            return {
                input: null,
            };
        },
        computed: {
            id() {
                return this.input ? this.input.$el.id : null;
            },
        },
        methods: {
            setInput(input) {
                this.input = input;
            },
        },
        provide() {
            return {
                $field: this,
            }
        },
    }
</script>